import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap, Shield, Sparkles } from 'lucide-react';

const Home = () => {
  const navigate = useNavigate();
  // BRAND LOGO: Replace with your external image link
  const brandLogo = "../assets/logo.png";

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] animate-in fade-in zoom-in duration-1000">
      {/* Brand Section */}
      <div className="mb-8 flex flex-col items-center">
        <div className="relative">
          <div className="absolute -inset-4 bg-indigo-100 rounded-full blur-2xl opacity-50 animate-pulse"></div>
          <img 
            src={brandLogo} 
            alt="NoteOnQuick Brand" 
            className="relative w-24 h-24 md:w-32 md:h-32 object-contain transition-transform hover:scale-110 duration-300"
          />
        </div>
        <h1 className="mt-6 text-4xl md:text-6xl font-black text-gray-900 tracking-tight text-center leading-tight">
          NoteOn<span className="text-indigo-600">Quick</span>
        </h1>
      </div>

      <p className="text-gray-400 text-lg md:text-xl max-w-md mx-auto mb-10 text-center font-medium leading-relaxed px-4">
        The ultimate workspace for your fleeting thoughts. Fast, secure, and beautifully simple.
      </p>

      {/* Primary Action Button */}
      <button 
        onClick={() => navigate('/editor')}
        className="group relative bg-indigo-600 text-white px-10 py-5 rounded-[2.5rem] font-black text-xl shadow-2xl shadow-indigo-200 hover:bg-indigo-700 active:scale-95 transition-all flex items-center gap-3"
      >
        <Sparkles className="group-hover:rotate-12 transition-transform" />
        START WRITING
      </button>

      {/* Feature Pills */}
      <div className="mt-16 flex flex-wrap justify-center gap-4 px-4">
        <div className="flex items-center gap-2 bg-white px-5 py-3 rounded-2xl border border-gray-100 shadow-sm">
          <Zap size={18} className="text-amber-500" />
          <span className="text-sm font-bold text-gray-700">Instant Save</span>
        </div>
        <div className="flex items-center gap-2 bg-white px-5 py-3 rounded-2xl border border-gray-100 shadow-sm">
          <Shield size={18} className="text-green-500" />
          <span className="text-sm font-bold text-gray-700">Private</span>
        </div>
      </div>
    </div>
  );
};

export default Home;